import { type LocationId, type ExtendedLocationData, type AccountData, type LatLng, Logger } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { locationKey, locationsKey } from '../keys'

const logger = new Logger('useLocationCache')
// logger.level = 'verbose'

export function useLocationCache() {
  const queryClient = useQueryClient()
  const clearItem = (locationId: LocationId): void => {
    // the basic key prefixes the extended one, so this clears both cached shapes
    queryClient.invalidateQueries({ queryKey: locationKey(locationId, false) })
  }
  return {
    replaceItem: (locationId: LocationId, data: ExtendedLocationData) => {
      queryClient.setQueryData(locationKey(locationId), data)
    },
    clearItem,
    updatePrescreen: (locationId: LocationId) => {
      clearItem(locationId)
    },
    updateLocationAccount: (locationId: LocationId, account: AccountData) => {
      logger.verbose('updateLocationAccount', locationId, account)
      queryClient.setQueryData<ExtendedLocationData>(locationKey(locationId), (old) => {
        if (!old) return old
        return {
          ...old,
          account: old.account && old.account.accountId === account.accountId ? account : old.account,
          accounts: old.accounts?.map((a) => (a.accountId === account.accountId ? account : a)),
        }
      })
    },
    invalidateSectorCache(latLng: LatLng): void {
      const queryKey = locationsKey(latLng)
      queryClient.invalidateQueries({ queryKey })
    },
  }
}
